import { Pipe, PipeTransform } from '@angular/core';
import {LocalUser} from '@app/state/local-user.state';
import {RemoteUserAdditionalInfoStateModel} from '@app/state/remote-users.state';
import {AccessType} from '@app/modules/shared/data/constants';
import {User} from '@app/models/vcr-entity/user';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';

@Pipe({
  name: 'isStaff'
})
export class IsStaffPipe implements PipeTransform {

  public transform(user: User | LocalUser | RemoteParticipantInfo | RemoteUserAdditionalInfoStateModel): boolean {
    return user.accessType === AccessType.TEACHER || user.accessType === AccessType.SUPPORT || user.accessType === AccessType.OBSERVER;
  }
}
